import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/crm/ProtectedRoute";
import { CrmLayout } from "@/components/crm/CrmLayout";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import LeadsPage from "@/pages/crm/LeadsPage";
import LeadDetailPage from "@/pages/crm/LeadDetailPage";
import UsersPage from "@/pages/crm/admin/UsersPage";
import ServicesPage from "@/pages/crm/admin/ServicesPage";
import CenterPage from "@/pages/crm/admin/CenterPage";
import RulesPage from "@/pages/crm/admin/RulesPage";
import GhlIntegrationPage from "@/pages/crm/admin/GhlIntegrationPage";
import DashboardPage from "@/pages/crm/DashboardPage";
import PipelinePage from "@/pages/crm/PipelinePage";
import ConversationsPage from "@/pages/crm/ConversationsPage";
import AppointmentsPage from "@/pages/crm/AppointmentsPage";

const adminOnly = (el) => <ProtectedRoute roles={["admin"]}>{el}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/crm" element={<ProtectedRoute><CrmLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/crm/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="pipeline" element={<PipelinePage />} />
            <Route path="conversaciones" element={<ConversationsPage />} />
            <Route path="conversaciones/:id" element={<ConversationsPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="leads/:id" element={<LeadDetailPage />} />
            <Route path="citas" element={<AppointmentsPage />} />
            <Route path="admin/usuarios" element={adminOnly(<UsersPage />)} />
            <Route path="admin/servicios" element={adminOnly(<ServicesPage />)} />
            <Route path="admin/centro" element={adminOnly(<CenterPage />)} />
            <Route path="admin/asignacion" element={adminOnly(<RulesPage />)} />
            <Route path="admin/integraciones" element={adminOnly(<GhlIntegrationPage />)} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
